import { QtmCheckbox, QtmIcon } from '@qtm/react';
import clsx from 'clsx';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { UserTableModel, userTableColumns } from 'modules/Users/DataTableDef';
import { User } from 'shared/model/user.model';
import { setSelection, setSortColumn, setSortDirection } from 'shared/reducers/usersTableSlice';

type Props = {
  users: User[];
};

const DataTableHeader = ({ users }: Props) => {
  const dispatch = useAppDispatch();
  const sortColumn = useAppSelector(state => state.usersTable.sortColumn);
  const sortDirection = useAppSelector(state => state.usersTable.sortDirection);
  const selection = useAppSelector(state => state.usersTable.selection);

  const onSort = (column: keyof UserTableModel) => () => {
    if (column !== sortColumn) {
      dispatch(setSortColumn(column));
      dispatch(setSortDirection('asc'));
    } else {
      if (sortDirection === null) {
        dispatch(setSortDirection('asc'));
      } else if (sortDirection === 'asc') {
        dispatch(setSortDirection('desc'));
      } else {
        dispatch(setSortDirection(null));
        dispatch(setSortColumn(null));
      }
    }
  };

  const onCheckboxChange = () => {
    if (selection.length === users.length) {
      dispatch(setSelection([]));
    } else {
      dispatch(setSelection(users.map(user => user.id)));
    }
  };

  const indeterminate = selection.length > 0 && selection.length < users.length;

  return (
    <thead>
      <tr>
        <th className="checkbox">
          <QtmCheckbox
            color="primary"
            size="medium"
            checked={selection.length === users.length && users.length > 0}
            indeterminate={indeterminate}
            onValueChanged={onCheckboxChange}
          />
        </th>
        {userTableColumns.map(column => {
          const isSorted = sortColumn === column.name;
          return (
            <th
              key={column.name}
              style={column.style}
              onClick={onSort(column.name)}
              className={clsx({ isSorted })}
            >
              <span>{column.header}</span>
              {isSorted && sortDirection ? (
                sortDirection === 'desc' ? (
                  <QtmIcon icon="arrow_drop_down" size="large" />
                ) : (
                  <QtmIcon icon="arrow_drop_up" size="large" />
                )
              ) : (
                <QtmIcon icon="sort" />
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default DataTableHeader;
